import React, { useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Button } from '../../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { FileText, MessageSquare, MapPin, Mail, LogOut, Palette, Users, Image, Search, Send, Layout, Lock, Camera } from 'lucide-react';

const AdminDashboard = () => {
  const { user, logout, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/admin/login');
    }
  }, [isAuthenticated, navigate]);

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  const menuItems = [
    { title: 'Gerenciar Conteúdo', icon: FileText, path: '/admin/blog', description: 'Blog, Depoimentos e Regiões' },
    { title: 'Email Marketing', icon: Send, path: '/admin/email', description: 'Mala Direta e Newsletters' },
    { title: 'Páginas Estáticas', icon: Layout, path: '/admin/content', description: 'Editar Serviços, Sobre e Contacto' },
    { title: 'CRM - Clientes', icon: Mail, path: '/admin/crm', description: 'Histórico de Atendimento e Tarefas' },
    { title: 'SEO das Páginas', icon: Search, path: '/admin/seo', description: 'Títulos e Descrições para Google' },
    { title: 'Seção Decorativa', icon: Image, path: '/admin/decorative', description: 'Imagens e Textos Decorativos' },
    { title: 'Personalizar Tema', icon: Palette, path: '/admin/theme', description: 'Cores, Fontes e Imagens de Fundo' },
    { title: 'Páginas Privadas', icon: Lock, path: '/admin/private-pages', description: 'Off-Market & Brochuras Confidenciais' },
    { title: 'Snapshot de Página', icon: Camera, path: '/admin/snapshot', description: 'Capturar HTML renderizado para partilhar com Claude / IAs' },
    { title: 'Gerenciar Utilizadores', icon: Users, path: '/admin/users', description: 'Criar e Gerir Logins de Admin' },
  ];

  if (!isAuthenticated) {
    return null;
  }

  return (
    <div className="min-h-screen bg-brand-soft">
      {/* Header */}
      <div className="bg-white border-b border-brand-accent">
        <div className="container mx-auto px-4 sm:px-6 py-3 sm:py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-2 sm:space-x-4 flex-1 min-w-0">
              <img 
                src="/logo-ybp.png" 
                alt="Your Broker Portugal" 
                className="h-8 sm:h-12 w-auto"
              />
              <div className="hidden sm:block">
                <h1 className="text-lg sm:text-xl font-display font-semibold text-brand-text">Painel Admin</h1>
                <p className="text-xs sm:text-sm text-brand-text-secondary">Bem-vindo, {user?.name || 'Admin'}</p>
              </div>
            </div>
            <div className="flex items-center space-x-2">
              <Button asChild variant="outline" size="sm" className="text-xs sm:text-sm border-brand-primary text-brand-primary hover:bg-brand-primary hover:text-white">
                <Link to="/">Ver Site</Link>
              </Button>
              <Button onClick={handleLogout} variant="outline" size="sm" className="hidden sm:flex">
                <LogOut className="w-4 h-4 mr-2" />
                Sair
              </Button>
              <Button onClick={handleLogout} variant="outline" size="sm" className="sm:hidden p-2">
                <LogOut className="w-4 h-4" />
              </Button>
            </div>
          </div>
          <div className="sm:hidden mt-2">
            <h1 className="text-base font-display font-semibold text-brand-text">Painel Admin</h1>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 sm:px-6 py-6 sm:py-12">
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
          {menuItems.map((item) => {
            const Icon = item.icon;
            return (
              <Link to={item.path} key={item.path}>
                <Card className="hover:shadow-lg transition-all duration-300 cursor-pointer group border-brand-accent/50">
                  <CardHeader className="pb-3 sm:pb-4">
                    <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-brand-primary flex items-center justify-center mb-3 sm:mb-4 group-hover:bg-brand-primary-hover transition-colors">
                      <Icon className="w-5 h-5 sm:w-6 sm:h-6 text-brand-accent" />
                    </div>
                    <CardTitle className="text-base sm:text-lg font-display text-brand-text">{item.title}</CardTitle>
                  </CardHeader>
                  <CardContent className="pt-0">
                    <p className="text-xs sm:text-sm text-brand-text-secondary">{item.description}</p>
                  </CardContent>
                </Card>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
